import { components } from "./components/index";
import { events } from "./events/index";


const EntityInformationSection = {
  components,
  events
};

export { EntityInformationSection };